// extracted by mini-css-extract-plugin
export default {"Welcome":"Welcome_Welcome__8iCd1","Text":"Welcome_Text__aFPHV"};